import Money from "js-money/lib";

export const currencySymbol = {
    props: {
        currency: {
            type: String,
            required: false,
            default: 'GBP'
        }
    },
    methods: {
        convertCurrencyCodeToPrefix(code) {

            let currency = Money[code];

            if (currency.code == 'AUD') {
                return "A$";
            }

            if (currency.code == 'SGD') {
                return "SGD"
            }

            if (currency.code == 'ISK') {
                return "kr";
            }

            if (currency.code === 'USD') {
                return 'US$';
            }

            return currency.symbol;
        }
    }
}

/**
 * Gets the number of decimal places to use when showing a currency
 *
 * @type {{methods: {getDecimalPlacesForCurrency(*): *}, props: {currency: {default: string, type: StringConstructor, required: boolean}}}}
 */
export const currencyDecimals = {
    props: {
        currency: {
            type: String,
            required: false,
            default: 'GBP'
        }
    },
    methods: {
        getDecimalPlacesForCurrency(code) {

            let currency = Money[code];

            if (code == 'ISK') {
                return 2;
            }

            return currency.decimal_digits;
        }
    }
}



// WEBPACK FOOTER //
// ./src/Assets/mixins/currency.js